import {
  SET_COMPANIES,
  SAVE_COMPANY,
  UPDATE_COMPANY_STOR,
  DOWNLOAD,
  UPLOAD,
  SET_IS_LOADING,
  SET_SPOT_TO_EDIT,
  SET_NEWS_TO_EDIT,
  GET_SPOT_TO_EDIT,
  GET_NEWS_TO_EDIT,
  SET_USER,
  UPDATE_SPOT_DATABASE,
  GET_NEWS,
  SET_NEWS,
  SAVE_CATEGORIES,
  SET_CATEGORY_TO_EDIT,
  GET_CATEGORY_TO_EDIT,
  TOKEN_AUTH,
  RESET_ACTIVE_TYPE,
  SAVE_PREMIUM_PLAN,
  GET_PREMIUM_PLAN_TO_EDIT,
  SET_PREMIUM_PLAN_TO_EDIT,
  SET_BLOG_TO_EDIT
} from "./constants";

export function setIsLoading(status) {
  return {
    type: SET_IS_LOADING,
    status,
  };
}
export function removeActiveType() {
  return {
    type: RESET_ACTIVE_TYPE
  }
}
export function setCompanies(companies) {
  return {
    type: SET_COMPANIES,
    companies,
  };
}

export function saveCompany(company, typeCompany) {
  return {
    type: SAVE_COMPANY,
    company,

    typeCompany,
  };
}

export function updateSpotStor(company, companyType) {
  return {
    type: UPDATE_COMPANY_STOR,
    company,
    companyType,
  };
}

export function download(companyType) {
  return {
    type: DOWNLOAD,
    companyType
  };
}

export function upload(country, data, typeUpload) {
  return {
    type: UPLOAD,
    country,
    data,
    typeUpload,
  };
}


export function getSpotByTypeKey(data) {
  return {
    type: GET_SPOT_TO_EDIT,
    data,
  };
}

export function getOneNewsByKey(data) {
  return {
    type: GET_NEWS_TO_EDIT,
    data,
  };
}

export function setSpotToEdit(spot) {
  return {
    type: SET_SPOT_TO_EDIT,
    spot,
  };
}

export function setNewsToEdit(news) {
  return {
    type: SET_NEWS_TO_EDIT,
    news,
  };
}
export function setBlogToEdit(news) {
  return {
    type: SET_BLOG_TO_EDIT,
    news,
  };
}

export function setUser({ user, token }) {
  localStorage.setItem('token_user', token)
  user.token = token
  return {
    type: SET_USER,
    user,
  };
}
// export function tokenAuthServices() {
//   const token = null
//   const currentToken = localStorage.getItem('token_user')
//   if(currentToken) token = currentToken
//   return {
//     type: TOKEN_AUTH,
//     token,
//   };
// }

export function updateSpotDatabase(spot, spotType) {
  return {
    type: UPDATE_SPOT_DATABASE,
    spot,
    spotType,
  };
}

export function getNews(field, country) {
  return {
    type: GET_NEWS,
    field,
    country,
  };
}

export function setNews(news) {
  return {
    type: SET_NEWS,
    news,
  };
}

export function saveCategories(categories) {
  return {
    type: SAVE_CATEGORIES,
    categories,
  };
}

export function getCategoryText(data) {
  return {
    type: GET_CATEGORY_TO_EDIT,
    data
  };
}
export function setCategoryToEdit(category) {
  return {
    type: SET_CATEGORY_TO_EDIT,
    category,
  };
}
export function savePremiumPlan(plan) {
  return {
    type: SAVE_PREMIUM_PLAN,
    plan,
  };
}
export function setPremiumPlan(plan){
  return {
    type: SET_PREMIUM_PLAN_TO_EDIT,
    plan,
  };
}
export function getPremiumPlan(data) {
  return {
    type: GET_PREMIUM_PLAN_TO_EDIT,
    data
  };
}
